export type GamepadSnapshot = {
  index: number;
  axes: number[];
  buttons: boolean[];
  triggers: number[];
};

// Pooled snapshots keyed by gamepad index; arrays inside each snapshot are reused (length adjusted
// in place). pollGamepads returns a shared output buffer — callers must consume it within the frame.
const PAD_POOL: GamepadSnapshot[] = [];
const PAD_OUTPUT: GamepadSnapshot[] = [];

export function pollGamepads(): GamepadSnapshot[] {
  PAD_OUTPUT.length = 0;
  const pads = navigator.getGamepads ? navigator.getGamepads() : [];
  for (const pad of pads) {
    if (pad === null) continue;
    let snap = PAD_POOL[pad.index];
    if (snap === undefined) {
      snap = { index: pad.index, axes: [], buttons: [], triggers: [] };
      PAD_POOL[pad.index] = snap;
    }
    snap.index = pad.index;
    snap.axes.length = pad.axes.length;
    for (let i = 0; i < pad.axes.length; i++) snap.axes[i] = pad.axes[i] ?? 0;
    snap.buttons.length = pad.buttons.length;
    snap.triggers.length = pad.buttons.length;
    for (let i = 0; i < pad.buttons.length; i++) {
      const b = pad.buttons[i];
      snap.buttons[i] = b?.pressed ?? false;
      snap.triggers[i] = b?.value ?? 0;
    }
    PAD_OUTPUT.push(snap);
  }
  return PAD_OUTPUT;
}
